// extracted by mini-css-extract-plugin
export default {"root":"ImageDialog_root__Vrbyd","image":"ImageDialog_image__9QV71","closeButton":"ImageDialog_closeButton__f6mw2"};